module.exports = __webpack_public_path__ + "static/media/calling.0707a09b.mp3";